import React from "react";
import useTheme from "../hooks/useTheme";
import { Theme } from "../../providers/ThemeProvider";

const BlurContainer = ({
  isBlurred,
  children,
  title,
  text,
  customBorderColor,
}: {
  isBlurred: boolean;
  children: React.ReactNode;
  title: string;
  text: string;
  customBorderColor?: string;
}) => {
  const theme = useTheme();
  return (
    <div style={styles.container}>
      <div style={isBlurred ? styles.blurContainer : styles.unblurredContainer}>
        {children}
      </div>
      {isBlurred && (
        <div style={styles.messageContainer(theme, customBorderColor)}>
          <p style={styles.title(theme)}>{title}</p>
          <p style={styles.text(theme)}>{text}</p>
        </div>
      )}
    </div>
  );
};

export default BlurContainer;

const styles = {
  container: {
    position: "relative" as "relative",
    width: "100%",
    height: "100%",
  },
  blurContainer: {
    filter: "blur(5px)",
    WebkitFilter: "blur(5px)", // For Safari
    pointerEvents: "none", // Optional: Prevent interaction with blurred content
  },
  unblurredContainer: {
    filter: "none", // To reset blur when needed
  },
  messageContainer: (theme: Theme, customBorderColor: string | undefined) => ({
    position: "absolute" as "absolute",
    top: "60px",
    left: "50%",
    transform: "translateX( -50%)",
    textAlign: "center" as "center",
    border: `1px solid ${
      customBorderColor ?? theme.colors_ds.NEUTRAL_BORDER_WEAK
    }`,
    borderRadius: "8px",
    backgroundColor: theme.colors_ds.NEUTRAL_BG_MAIN,
    width: "92%",
    padding: "40px 16px",
    display: "flex",
    flexDirection: "column" as "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
    boxShadow: "var(--box-shadow-general)",
  }),
  title: (theme: Theme) => ({
    fontFamily: "var(--font-Bold)",
    fontSize: "14px",
    color: theme.colors_ds.NEUTRAL_TEXT_STRONG,
    margin: 0,
  }),
  text: (theme: Theme) => ({
    fontFamily: "var(--font-Medium)",
    fontSize: "12px",
    color: theme.colors_ds.NEUTRAL_TEXT_STRONG,
    margin: 0,
  }),
};
